import { METHOD } from 'services/method'

export const API_SPECIAL_PROMO = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/special-promo',
        method: METHOD.GET,
    },
    URL_IMAGE_TITLE: {
        api: '/v1/dashboard-admin/main-page/home-page/special-promo/storage-url/attachment',
        method: METHOD.POST,
    },
    VOUCHER_LIST: {
        api: '/v1/dashboard-admin/main-page/home-page/special-promo/voucher',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/special-promo',
        method: METHOD.PUT,
    },
}
